module.exports = __webpack_public_path__ + "static/media/manager-portrait.4dcf9336.jpg";